import { FC } from 'react';

interface Step {
  label: string;
  icon: string;
}

const STEPS: Step[] = [
  { label: 'Objectifs',    icon: '🎯' },
  { label: 'Stratégie',    icon: '🧭' },
  { label: 'Finances',     icon: '💰' },
  { label: 'Sélection',    icon: '📊' },
  { label: 'Notifications',icon: '🔔' },
  { label: 'Résumé',       icon: '✅' },
];

interface WizardProgressProps {
  currentStep: number;
  completedStep: number;
  onStepClick: (step: number) => void;
}

export const WizardProgress: FC<WizardProgressProps> = ({ currentStep, completedStep, onStepClick }) => {
  // Les lignes partent du centre du 1er cercle (left-5 = 20px = w-10/2)
  // jusqu'au centre du dernier (right-5). La largeur de la barre active est
  // proportionnelle à l'espace entre les centres : (100% - 40px).
  const ratio = STEPS.length > 1 ? currentStep / (STEPS.length - 1) : 0;

  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between relative">
        <div className="absolute top-5 left-5 right-5 h-0.5 bg-gray-200 dark:bg-gray-700 z-0" />
        <div
          className="absolute top-5 left-5 h-0.5 bg-blue-500 z-0 transition-all duration-300"
          style={{ width: `calc(${ratio * 100}% - ${ratio * 40}px)` }}
        />
        {STEPS.map((step, index) => {
          const isCompleted = index <= completedStep;
          const isCurrent = index === currentStep;
          const isClickable = index <= completedStep + 1;
          return (
            <button
              key={index}
              onClick={() => isClickable && onStepClick(index)}
              disabled={!isClickable}
              className={`relative z-10 flex flex-col items-center gap-1 group ${isClickable ? 'cursor-pointer' : 'cursor-not-allowed'}`}
            >
              <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all
                ${isCurrent ? 'bg-blue-600 text-white ring-4 ring-blue-100 dark:ring-blue-900' :
                  isCompleted ? 'bg-blue-500 text-white' :
                  'bg-gray-200 dark:bg-gray-700 text-gray-400'}`}>
                {isCompleted && !isCurrent ? '✓' : step.icon}
              </div>
              <span className={`text-[10px] sm:text-xs font-medium hidden sm:block
                ${isCurrent ? 'text-blue-600' : isCompleted ? 'text-gray-600 dark:text-gray-300' : 'text-gray-400'}`}>
                {step.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
